import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { QuestionCircleOutlined } from '@ant-design/icons';
import { Popover } from "antd";
const HelpLabel = ({ title, helpText, size = "normal", iconSize = "normal" }) => {
    const iconStyle = iconSize === "large" ? { fontSize: '16pt' } : { fontSize: '12pt' };
    const className = size === "large" ? "popover-help-lg" : "popover-help";
    return (_jsxs("span", { children: [title, "\u00A0", _jsx(Popover, { destroyOnHidden: true, placement: "top", content: _jsx("div", { className: className, children: helpText }), children: _jsx(QuestionCircleOutlined, { style: iconStyle }) })] }));
};
export default HelpLabel;
